import React, { useState, useEffect, useRef } from 'react';
import ArrowBack from '../../assets/icons/arrow-back.svg'
import Eye from '../../assets/icons/eye.svg'
import HideEye from '../../assets/icons/close-eye.svg'
import BlueLogo from '../../assets/images/blue-logo.svg'
import { Form } from 'react-bootstrap';
import 'primeicons/primeicons.css';
import { ChangePassword, checkOtpChangePassword, sendOtpChangePassword } from "../../utils/api"
import Loader from '../loader/loader'
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import useStickToTopModal from '../../hooks/useStickToTopModal';
import useToastNotification from '../../hooks/useToastNotification';


function ChangePasswordFun() {
  const toast = useRef(null);
  const [mobileVisible, setMobileVisible] = useState(true);
  const [otpVisible, setOtpVisible] = useState(false);
  const [mobileSection, setMobileSection] = useState(true)
  const [OTPSection, setOTPSection] = useState(false)
  const [mobileLoader, setMobileLoader] = useState(false)
  const [changePassLoader, setChangePassLoader] = useState(false)
  const [validated, setValidated] = useState(false);
  const [changePassValidated, setChangePassValidated] = useState(false);
  const [mobile, setMobile] = useState('')
  const [otp, setOtp] = useState('')
  const [password, setPassword] = useState('')
  const [time, setTime] = useState(240); // Initialize with 3 minutes (180 seconds)
  const [isActive, setIsActive] = useState(false);
  const [resendBtn, setResendBtn] = useState(true);
  const [typePassword, setTypePassword] = useState('password');


  const { showError, showSuccess } = useToastNotification();


  const getOTPPassword = async (e) => {

    e.preventDefault();

    const form = e.currentTarget;
    if (form.checkValidity() === true) {
      setTime(240)
      setIsActive(true);
      setResendBtn(true);
      setMobileLoader(true)
      if (mobile.length == 11 && mobile.startsWith("09")) {
        try {
          let res = await sendOtpChangePassword({
            mobile
          })
          if (res.data.isSuccess) {
            setMobileLoader(false)
            setMobileVisible(false)
            setOtpVisible(true)
          }

          else {
            setMobileLoader(false)
            let message = {
              text: res.data.message
            }
            showError(message)
          }
        } catch (error) {
          setMobileLoader(false)
          let errorMessage = JSON.parse(error.response.data.error)
          let message = {
            text: errorMessage.error
          }
          showError(message)
        }
      } else {
        setMobileLoader(false)
        let message = {
          text: 'شماره موبایل را صحیح وارد کنید'
        }
        showError(message)
      }

    }
    setValidated(true)

  }
  const changeMobile = () => {
    setMobileVisible(true)
    setOtpVisible(false)
  }
  const checkOtp = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === true) {
      setChangePassLoader(true)
      if (otp.length == 6) {
        try {
          let res = await checkOtpChangePassword({
            mobile,
            otp
          })

          if (res.data.isSuccess) {
            changePass()
          }
          else {
            setChangePassLoader(false)
            let message = {
              text: res.data.message
            }
            showError(message)
          }
        } catch (error) {
          setChangePassLoader(false)
          let message = {
            text: 'خطا در ارتباط با سرور'
          }
          showError(message)
        }
      } else {
        setChangePassLoader(false)
        let message = {
          text: 'کد ارسال شده را صحیح وارد کنید.'
        }
        showError(message)
      }

    }
    setChangePassValidated(true)

  }
  const changePass = async (e) => {

    try {
      let res = await ChangePassword({
        mobile,
        password
      })

      if (res.data.isSuccess) {
        setChangePassLoader(false)
        window.location.href = '/'
      }
      else {
        setChangePassLoader(false)
        let message = {
          text: res.data.message
        }
        showError(message)
      }
    } catch (error) {
      setChangePassLoader(false)
      let message = {
        text: 'خطا در ارتباط با سرور'
      }
      showError(message)
    }
  }
  const showPassword = () => {
    setTypePassword('text')
  }
  const hidePassword = () => {
    setTypePassword('password')
  }


  //setTimer
  useEffect(() => {
    let timerId;
    if (isActive && time > 0) {
      timerId = setInterval(() => {
        setTime(prevTime => prevTime - 1);
      }, 1000);
    } else if (time === 0) {
      onTimerFinish(); // Call the function when the timer reaches 0
    }
    // Cleanup interval on component unmount or when time reaches 0
    return () => clearInterval(timerId);
  }, [isActive, time]);

  //finishTimer
  const onTimerFinish = () => {
    setResendBtn(false);
  }

  const formatTime = (time) => {
    const minutes = String(Math.floor(time / 60)).padStart(2, '0');
    const seconds = String(time % 60).padStart(2, '0');
    return `${minutes}:${seconds}`;
  }


  const { modalClassName, onKeyboardClose, onKeyboardOpen, stickToTop } = useStickToTopModal();
  // useEffect(() => {
  //   if (mobileVisible === true || otpVisible === true) {
  //     return onKeyboardOpen();
  //   }
  //   onKeyboardClose();
  // }, [mobileVisible, otpVisible])


  return (
    <>
      <Toast ref={toast} />
      <Dialog className={`animation ${stickToTop ? modalClassName : ''}`} header="رمز عبور" visible={mobileVisible} style={{ width: '30vw' }} onHide={() => { if (!mobileVisible) return; setMobileVisible(false); }}>
        <div className='login-card w-100'>
          <div className='item mx-0' >
            <h6 className='text-xl font-medium	color-primary2 mt-5'>جهت تغییر رمز عبور، شماره موبایل خود را وارد کنید.</h6>
            <Form className='mt-5' noValidate validated={validated} onSubmit={(e) => getOTPPassword(e)}>
              <Form.Group controlId="text" >
                <Form.Label style={{ fontWeight: '600' }}>شماره موبایل</Form.Label>
                <Form.Control type="number" inputMode="numeric" maxLength="11" required value={mobile} onChange={(e) => {
                  if (e.target.value.length <= 11) {
                    setMobile(e.target.value); // محدود کردن مقدار به 11 کاراکتر
                  }
                }}
                  onKeyDown={(e) => {

                    if (e.key === 'Enter') {
                      e.preventDefault(); // Prevent form submission
                      getOTPPassword(e); // Call login function
                    }
                  }} onBlur={onKeyboardClose} onFocus={onKeyboardOpen} />
              </Form.Group>
              <button className='btn btn-primary w-100 mt-2 text-center' disabled={mobileLoader} type='submit' style={{ width: 'auto' }}>ورود {mobileLoader && <Loader />}</button>
            </Form>
          </div>
        </div>
      </Dialog>
      <Dialog header="رمز عبور" className={`animation ${stickToTop ? modalClassName : ''}`} visible={otpVisible} style={{ width: '30vw' }} onHide={() => { if (!otpVisible) return; setOtpVisible(false); }}>
        <div className='login-card w-100'>
          <div className='item mx-0' >
            <h6 className='text-xl font-medium	color-primary2 mt-5'>رمز عبور جدید و کد تایید ارسالی  برای شماره {mobile} را وارد کنید.</h6>
            <Form className='mt-5' noValidate validated={changePassValidated} onSubmit={(e) => checkOtp(e)}>
              <Form.Group controlId="text" >
                <Form.Label style={{ fontWeight: '600' }}>رمزعبور جدید</Form.Label>
                <div className='input-icon'>
                  <Form.Control onBlur={onKeyboardClose} onFocus={onKeyboardOpen} type={typePassword} required value={password} onChange={(e) => setPassword(e.target.value)}
                  />
                  {typePassword === 'password' ? <img src={Eye} alt="" onClick={showPassword} /> : <img src={HideEye} alt="" onClick={hidePassword} />}
                </div>
              </Form.Group>
              <Form.Group controlId="postalCode" >
                <Form.Label className='mt-2' style={{ fontWeight: '600' }}>کد تایید</Form.Label>
                <Form.Control className='number' type="number" autocomplete="one-time-code" inputMode="numeric" required value={otp} onChange={(e) => {
                  if (e.target.value.length <= 6) {
                    setOtp(e.target.value); // محدود کردن مقدار به 11 کاراکتر
                  }
                }} onKeyDown={(e) => {

                  if (e.key === 'Enter') {
                    e.preventDefault(); // Prevent form submission
                    checkOtp(e); // Call login function
                  }
                }} onBlur={onKeyboardClose} onFocus={onKeyboardOpen} />

              </Form.Group>
          
              <button type='button' disabled={resendBtn} className='btn w-100 text-center mt-2 number' onClick={getOTPPassword}> {resendBtn ? formatTime(time) : 'ارسال مجدد'}</button>
              <button className='btn btn-primary w-100 mt-1 text-center' disabled={changePassLoader} type='submit' style={{ width: 'auto' }}>ادامه {changePassLoader && <Loader />}</button>
              <button type='button' className='btn w-100 text-center color-primary' onClick={changeMobile}>تغییر شماره موبایل</button>

            </Form>
          </div>
        </div>
      </Dialog>





    </>
  )

}
export default ChangePasswordFun;
